import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import find from 'lodash/find';

import Header from './components/Header.jsx';
import DisplayFeedPreview from '../preview/DisplayFeedPreview';
import { makesRequest, getMakesStore } from './data/makes';
import { feedRequest, getFeedsStore, getFeedRowFromModelYear } from './data/feeds';
import { getModelsYearsStore, getModelsForMake, getYearsForModel, getModelFromId } from './data/models-years';
import DisplayFeedSettings from '../settings/DisplayFeedSetttings';
import { mergeOverridesIntoFeed } from '../feed-overrides/data/feed-overrides';

const hometownMotorsLogo = `data:image/png;base64,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`;

const styles = {
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: '5px',
    height: '100%',
  },
  header: {
    gridColumnEnd: 'span 12',
  },
  previewArea: {
    gridColumnEnd: 'span 8',
    alignSelf: 'center',
    justifySelf: 'center',
  },
  settings: {
    gridColumnEnd: 'span 4',
  },
};

const autoSelectModelYearIfListOfOne = (ymmt, modelsStore) => {
  const { makeId, modelId } = ymmt;
  const models = getModelsForMake(makeId, modelsStore);

  const autoSelect = {};
  if (models.length === 1) {
    autoSelect.modelId = models[0].modelId;
  }

  const foundModel = find(models, model => model.modelId === modelId);
  if (foundModel && foundModel.years.length === 1) {
    autoSelect.year = foundModel.years[0];
  }
  return autoSelect;
};

const selectFeedRowFromYMM = ({ makeId, modelId, year, feeds, models }) => {
  const makeModels = getModelsForMake(makeId, models);
  const model = getModelFromId(makeModels, modelId) || {};
  return getFeedRowFromModelYear(model.displayName, year, feeds.makeIdFeedDict[makeId]);
};

class DisplayMocker extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      overrides: {
        dealerName: 'Hometown Motors',
        dealerLogoUrl: hometownMotorsLogo,
      },
    };
  }

  componentDidMount() {
    const { fetchMakes } = this.props;
    fetchMakes();
  }

  handleYMMTUpdate = (ymmt) => {
    const { makeId } = ymmt;
    const { feeds } = this.props;

    if (makeId && !feeds.makeIdFeedDict[makeId]) {
      this.props.fetchFeed(makeId);
    }

    const autoSelectedYMMT = autoSelectModelYearIfListOfOne(ymmt, this.props.models);
    const updatedYMM = { ...ymmt, ...autoSelectedYMMT };
    const selectedFeedRow = selectFeedRowFromYMM({ ...updatedYMM, feeds, models: this.props.models });
    this.setState(state => ({ ...state, ...updatedYMM, selectedFeedRow }));
  }

  handleSettingChange = (settings) => {
    const { makeId, modelId, year, ...overrides = {} } = settings;

    if (makeId || modelId || year) {
      this.handleYMMTUpdate({ makeId, modelId, year });
    }

    if (Object.keys(overrides).length > 0) {
      this.handleOverrideChange(overrides);
    }
  }

  handleOverrideChange = (overrideChanges) => {
    const { overrides: prevOverrides } = this.state;
    const overrides = { ...prevOverrides, ...overrideChanges };
    this.setState((state) => ({ ...state, overrides }));
  }

  render() {
    const { classes, makes } = this.props;
    const models = getModelsForMake(this.state.makeId, this.props.models);
    models.loading = this.props.feeds.loading;
    models.error = this.props.feeds.error;
    const years = getYearsForModel(models, this.state.modelId);
    const feed = this.state.selectedFeedRow ? [this.state.selectedFeedRow] : [];
    const feedWOverrides = mergeOverridesIntoFeed(feed, this.state.overrides);

    return (
      <div className={classes.container}>
        <Header className={classes.header} />
        <DisplayFeedPreview className={classes.previewArea} feed={feedWOverrides} />
        <DisplayFeedSettings
          className={classes.settings}
          stores={{ makes, models, years }}
          ymmt={this.state}
          feedRow={this.state.selectedFeedRow}
          feedOverrides={this.state.overrides}
          onChange={this.handleSettingChange}
        />
      </div>
    );
  }
}

DisplayMocker.propTypes = {
  classes: PropTypes.object.isRequired,
  makes: PropTypes.object,
  models: PropTypes.object,
  feeds: PropTypes.object,
  fetchMakes: PropTypes.func,
  fetchFeed: PropTypes.func,
};

const mapStateToProps = (state) => ({
  settings: state.editorSettings,
  makes: getMakesStore(state),
  feeds: getFeedsStore(state),
  models: getModelsYearsStore(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  fetchMakes: makesRequest,
  fetchFeed: feedRequest,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(DisplayMocker));




// WEBPACK FOOTER //
// ./src/main/DisplayMocker.jsx